import { ChangeEvent, FunctionComponent, useCallback, useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';
import spamStatuses from '@stores/spamStatuses';
import useTranslate from '@hooks/useTranslate';
import { useStore } from 'effector-react';
import localeWeightStore, { LOCALE, localeWeightMap, setLocaleWeight } from '@stores/localeWeight';
import componentContent from './SpamStatusFilters.content.json';

interface SpamStatusFilterProps {}

const { Option } = Select;

const SpamStatusFilter: FunctionComponent<SpamStatusFilterProps> = () => {
  const content = useTranslate(componentContent);
  const localeName = useStore(localeWeightStore);
  const { filters, setFilters } = useStore(spamStatuses);

  const [nicknameFilter, setNicknameFilter] = useState<string>('');
  const [authorIdFilter, setAuthorIdFilter] = useState<string>('');

  useEffect(() => {
    setNicknameFilter(filters.nickname || '');
    setAuthorIdFilter(filters.statusAuthorId || '');
  }, [filters]);

  const onNicknameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setNicknameFilter(e.currentTarget.value);
  };

  const searchByNickname = (nickname: string) => {
    setFilters({ ...filters, nickname: nickname || '' });
  };

  const onIdChange = (e: ChangeEvent<HTMLInputElement>) => {
    setAuthorIdFilter(e.currentTarget.value);
  };

  const searchByAuthorId = (authorId: string) => {
    setFilters({ ...filters, statusAuthorId: authorId || '' });
  };

  const onChangeLocale = useCallback(
    (locale: LOCALE) => {
      setLocaleWeight(locale);
      setFilters({ ...filters, locale });
    },
    [filters],
  );

  return (
    <Form layout='vertical'>
      <Form.Item label={content.seacrh_by_nickname}>
        <Input.Search
          allowClear
          value={nicknameFilter}
          onSearch={searchByNickname}
          onChange={onNicknameChange}
        />
      </Form.Item>

      <Form.Item label={content.seacrh_by_id}>
        <Input.Search
          allowClear
          value={authorIdFilter}
          onSearch={searchByAuthorId}
          onChange={onIdChange}
        />
      </Form.Item>

      <Form.Item label={content.locale}>
        <Select
          value={localeName}
          style={{ width: 120 }}
          onChange={onChangeLocale}
        >
          {localeWeightMap &&
            Object.entries(localeWeightMap).map(([key, value]) => {
              return (
                <Option
                  value={key}
                  key={key}
                >
                  {value.name}
                </Option>
              );
            })}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default SpamStatusFilter;
